import React, {useState, useEffect} from "react";
import { DashboardUsersData } from "../../../network/api/DashboardUsersData";
import ButtonLoader from "../../../../../../../components/ButtonLoader";

export default function UserCards({userStats, setUserStats, setErrorMessage =null}) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchUsersStats = async () => {
            try {
                if (setErrorMessage) setErrorMessage(null);
                const response = await DashboardUsersData({limit: 5});
                if (response.status === "success") {
                    setUserStats(response.data);
                } else {
                    if (setErrorMessage)setErrorMessage({status:response.status ,message:response.message});
                }
            } catch (error) {
                if (setErrorMessage)setErrorMessage({status:400 ,message:"Failed to fetch user data"});
            } finally {
                setIsLoading(false);
            }
        };

        fetchUsersStats();
    }
    , [setUserStats, setErrorMessage]);

    return (
        <>
            <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                <div className="widget-stat card bg-danger">
                    <div className="card-body  p-4">
                        <div className="media">
                            <span className="me-3">
                                <i className="bi bi-calendar3"></i>
                            </span>
                            <div className="media-body text-white text-end">
                                <p className="mb-1">Registered Today</p>
                                <h3 className="text-white">{isLoading? <ButtonLoader />: userStats?.today_users || "0"}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                <div className="widget-stat card bg-primary">
                    <div className="card-body  p-4">
                        <div className="media">
                            <span className="me-3">
                                <i className="la la-users"></i>
                            </span>
                            <div className="media-body text-white">
                                <p className="mb-1">Total Users</p>
                                <h3 className="text-white">{isLoading? <ButtonLoader />: userStats?.total_users || "0"}</h3>
                                <div className="progress mb-2 bg-secondary">
                                    <div className="progress-bar progress-animated bg-white" style={{ width: `${userStats?.growth_rates?.past_30_days}%`}}  ></div>
                                </div>
                                <small>{userStats?.growth_rates?.past_30_days}% Increase in 30 Days</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                <div className="widget-stat card bg-success">
                    <div className="card-body  p-4">
                        <div className="media">
                            <span className="me-3">
                                <i className="la la-user-check"></i>
                            </span>
                            <div className="media-body text-white">
                                <p className="mb-1">Active Users</p>
                                <h3 className="text-white">{isLoading? <ButtonLoader />: userStats?.active_users || "0"}</h3>
                                <div className="progress mb-2 bg-secondary">
                                    <div className="progress-bar progress-animated bg-white" style={{ width: `${userStats?.growth_rates?.past_30_days_active}%`}} ></div>
                                </div>
                                <small>{userStats?.growth_rates?.past_30_days_active}% Increase in 30 Days</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            

            <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                <div className="widget-stat card bg-warning">
                    <div className="card-body  p-4">
                        <div className="media">
                            <span className="me-3">
                                <i className="fas fa-user-clock"></i>
                            </span>
                            <div className="media-body text-white">
                                <p className="mb-1">Pending Users</p>
                                <h3 className="text-white">{isLoading? <ButtonLoader />: userStats?.pending_users || "0"}</h3>
                                <div className="progress mb-2 bg-secondary">
                                    <div className="progress-bar progress-animated bg-white" style={{ width: `${userStats?.growth_rates?.past_30_days_pending}%`}} ></div>
                                </div>
                                <small>{userStats?.growth_rates?.past_30_days_pending}% Increase in 30 Days</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                <div className="widget-stat card">
                    <div className="card-body  p-4">
                        <div className="media">
                            <span className="me-3 bgl-danger">
                                <i className="fas fa-ban"></i>
                            </span>
                            <div className="media-body  text-end">
                                <p className="mb-1">Blocked Users</p>
                                <h3>{isLoading? <ButtonLoader />: userStats?.blocked_users || "0"}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                <div className="widget-stat card ">
                    <div className="card-body  p-4">
                        <div className="media">
                            <span className="me-3 bgl-info">
                                <i className="bi bi-calendar3"></i>
                            </span>
                            <div className="media-body  text-end">
                                <p className="mb-1">Registered This month</p>
                                <h3 >{isLoading? <ButtonLoader />: userStats?.this_month_users || "0"}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            


        </>
    );
}